import {
  put, takeEvery, all, select,
} from 'redux-saga/effects';
import { delay } from 'redux-saga';
import { operatorClient } from 'domain/HttpClients';
import { change, changeData } from 'circe/queryListing/actions';
import { getResults } from 'circe/queryListing/selectors';
import { REDUCER_NAME } from 'domain/fuse/auth/users/constants';
import { show as showNotification } from 'circe/notifications/actions';
import * as I18n from 'circe/I18n';
import createSage from 'domain/fuse/auth/users/components/Create/saga';
import EditSaga from 'domain/fuse/auth/users/components/Edit/saga';
import {
  profileActivated,
  profileSuspended,
  approveProfile,
  suspendProfile,
  keepProfileStatus,
  makeProfile,
  madeProfile,
  toggleMakingProfile,
} from './actions';

const PROFILE_STATUS = {
  ACTIVE: 'ACTIVE',
  SUSPENDED: 'SUSPENDED',
};

function* doApproveProfile(action) {
  const {
    payload: { id },
    type,
  } = action;

  try {
    const state = yield select();
    const resp = yield operatorClient.Patch(`/api/profiles/${id}/activate`).send();

    yield put(
      showNotification(
        I18n.str('profileActivatedSuccessfully', 'Profile Activated Successfully'),
        'success',
      ),
    );
    yield put(profileActivated(id, type));
  } catch (e) {
    console.error(e);
    yield put(keepProfileStatus());
  }
}

function* doDeclineProfile(action) {
  const {
    payload: { id },
    type,
  } = action;

  try {
    const resp = yield operatorClient.Patch(`/api/profiles/${id}/suspend`).send();
    yield put(
      showNotification(
        I18n.str('profileSuspendedSuccessfully', 'Profile Suspended Successfully'),
        'success',
      ),
    );
    yield put(profileSuspended(id, type));
    return true;
  } catch (e) {
    console.error(e);
    yield put(keepProfileStatus());
  }
}

function* doToggleProfileStatus(status = PROFILE_STATUS.ACTIVE, { payload }) {
  const state = yield select();
  yield delay(350);
  const reducerName = REDUCER_NAME;
  const results = yield getResults(state, reducerName);

  yield put(
    changeData(
      reducerName,
      results.map((item) => {
        if (payload.id === item.profileId) {
          if (status === PROFILE_STATUS.ACTIVE) {
            return {
              ...item,
              status: 'ACTIVE',
            };
          }
          return {
            ...item,
            status: 'SUSPENDED',
          };
        }

        return item;
      }),
    ),
  );
}

function* doMakeAndApproveProfile(action) {
  const state = yield select();
  const {
    payload: { id, role },
  } = action;
  try {
    const newProfile = yield operatorClient
      .Post(`/api/profiles/${id}/newProfile`)
      .withParams({ pid: id, role })
      .send();

    yield doApproveProfile({
      payload: {
        id: newProfile,
      },
    });

    yield put(madeProfile());

    yield put(
      showNotification(
        I18n.str('anotherProfileCreatedSuccessfully', 'Another Profile Created Successfully'),
        'success',
      ),
    );

    yield put(toggleMakingProfile());
  } catch (e) {
    yield put(
      showNotification(I18n.str('error', 'Something Went Wrong, Please try again'), 'error'),
    );
    console.error(e);
    yield put(madeProfile());
  }
}

function* doKeepProfileStatus() {
  const state = yield select();
  yield delay(350);
  const reducerName = REDUCER_NAME;
  const results = yield getResults(state, reducerName);

  yield put(changeData(reducerName, results));
}

function* watcher(context) {
  yield all([
    takeEvery(profileActivated().type, doToggleProfileStatus, PROFILE_STATUS.ACTIVE),
    takeEvery(profileSuspended().type, doToggleProfileStatus, PROFILE_STATUS.SUSPENDED),
    takeEvery(keepProfileStatus().type, doKeepProfileStatus),
    takeEvery(approveProfile().type, doApproveProfile),
    takeEvery(suspendProfile().type, doDeclineProfile),
    takeEvery(makeProfile().type, doMakeAndApproveProfile),
    createSage(context),
    EditSaga(context),
  ]);
}

export default watcher;
